import { utils } from '../utils/webUtils';
import { window } from '@wix/photography-client-lib';
var AccessibilityHelper = /** @class */ (function () {
    function AccessibilityHelper(galleryWrapper, props) {
        var _this = this;
        this.waitForFirstTabPress = function (event) {
            if (event.keyCode === 9) {
                event.preventDefault();
                window.removeEventListener('keydown', _this.waitForFirstTabPress);
                _this.tabWasPressed = true;
                _this.isAccessible = true;
                _this.galleryWrapper.clientSideFunctionsConnectedPromise.promise.then(function () {
                    // This makes sure we are not calling worker functions before they were set in the client side worker
                    _this.galleryWrapper.props.onAccessibilityChanged(true);
                });
                return false;
            }
        };
        this.galleryWrapper = galleryWrapper;
        this.galleryWrapperProps = props;
        this.update = this.update.bind(this);
        this.initAccessibility = this.initAccessibility.bind(this);
        this.cleanupAccessibility = this.cleanupAccessibility.bind(this);
        this.waitForFirstTabPress = this.waitForFirstTabPress.bind(this);
        this.isDevAccessibility = utils.shouldDebug('accessibility');
        this.tabWasPressed = false;
        this.isAccessible = false;
    }
    AccessibilityHelper.prototype.update = function (props) {
        var _this = this;
        this.galleryWrapperProps = props;
        if (this.galleryWrapper.state.isAccessible !==
            ((this.galleryWrapperProps.accessibilityEnabled ||
                this.isDevAccessibility) &&
                this.tabWasPressed)) {
            var isAccessible_1 = (this.galleryWrapperProps.accessibilityEnabled ||
                this.isDevAccessibility) &&
                this.tabWasPressed;
            if (this.isAccessible !== isAccessible_1) {
                this.parent.clientSideFunctionsConnectedPromise.promise.then(function () {
                    // This makes sure we are not calling worker functions before they were set in the client side worker
                    _this.parent.props.onDimensionsReady(_this.getDimensions());
                });
                this.isAccessible = isAccessible_1;
                this.galleryWrapper.clientSideFunctionsConnectedPromise.promise.then(function () {
                    // This makes sure we are not calling worker functions before they were set in the client side worker
                    _this.galleryWrapper.props.onAccessibilityChanged(isAccessible_1);
                });
            }
        }
    };
    AccessibilityHelper.prototype.initAccessibility = function () {
        if (this.galleryWrapperProps.accessibilityEnabled ||
            this.isDevAccessibility) {
            window.addEventListener('keydown', this.waitForFirstTabPress);
        }
    };
    AccessibilityHelper.prototype.cleanupAccessibility = function () {
        if (this.galleryWrapperProps.accessibilityEnabled ||
            this.isDevAccessibility) {
            window.removeEventListener('keydown', this.waitForFirstTabPress);
        }
    };
    return AccessibilityHelper;
}());
export default AccessibilityHelper;
//# sourceMappingURL=accessibilityHelper.js.map